import { MenuInterface } from "./../components/types/MenuInterface";

export const navList: MenuInterface[] = [
  {
    url: "/login",
    label: "Login",
  },
  {
    url: "/matricula",
    label: "Matricule-se",
    isButton: true,
  },
];
